export default __webpack_public_path__ + "1461ded5ec4aed882324e776917b80f9.svg";